import XHR from '@/request/http'
const $h = new XHR()
// url
const url = {
    lists:'/admin/v1/agents/knowledge/page',
    save:'/admin/v1/agents/knowledge/save',
    del:'/admin/v1/agents/knowledge/delete',
    get:'/admin/v1/agents/knowledge/detail',
}


export async function page(data)
{
    return $h.request(url.lists,data,'GET')
}

export async function save(data)
{
    return $h.request(url.save,data,'POST')
}

export async function del(data)
{
    return $h.request(url.del+'/'+data.id,{},'POST')
}

export async function get(data)
{
    return $h.request(url.get+'/'+data.id,{},'GET')
}
